import { render, staticRenderFns } from "./BlogArticle.vue?vue&type=template&id=f4038e6a"
import script from "./BlogArticle.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogArticle.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BlogArticle.vue?vue&type=style&index=0&id=f4038e6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports